import { type Psychologist } from '@avanta/shared/types/psychologists';
import { cn } from '@avanta/shared/utils/cn';
import { useFormContext } from 'react-hook-form';
import { AnimatedContainer } from 'components/ui/AnimatedContainer';
import { CONTAINER_LG_MAX_WIDTH } from '../../../styles';
import { AppointmentsReservePayload, type StepProps } from '../../../types';
import { DesktopView, MobileView } from './components';

export const PsychologistStep = ({
  handleNext,
  handleBack,
  nextStepName,
}: StepProps): React.ReactElement => {
  const { setValue } = useFormContext();

  const handleOnCheckedChange = (checked: boolean, psychologist: Psychologist): void => {
    setValue(AppointmentsReservePayload.psychologist, checked ? psychologist : null);
  };

  const handleOnBack = (): void => {
    setValue(AppointmentsReservePayload.dateTime, '');
    handleBack?.();
  };

  return (
    <AnimatedContainer className={cn(CONTAINER_LG_MAX_WIDTH, 'flex flex-col h-full')}>
      <DesktopView
        handleNext={handleNext}
        handleBack={handleOnBack}
        nextStepName={nextStepName}
        handleOnCheckedChange={handleOnCheckedChange}
      />
      <MobileView
        handleNext={handleNext}
        handleBack={handleOnBack}
        handleOnCheckedChange={handleOnCheckedChange}
      />
    </AnimatedContainer>
  );
};
